import { RcButton, styled } from '@ringcentral/juno';
import { onMobile, useProximaNovaSemibold } from '@/core/sc';

export const Button = styled(RcButton)`
  ${useProximaNovaSemibold};
  padding: 8px !important;
  font-size: 16px !important;

  ${onMobile} {
    padding-left: 0 !important;
  }
`;
